import { render, staticRenderFns } from "./CeoMediaNews.vue?vue&type=template&id=777d5cb9&scoped=true&"
import script from "./CeoMediaNews.vue?vue&type=script&lang=js&"
export * from "./CeoMediaNews.vue?vue&type=script&lang=js&"
import style0 from "./CeoMediaNews.vue?vue&type=style&index=0&id=777d5cb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777d5cb9",
  null
  
)

export default component.exports